module.exports = __webpack_public_path__ + "img/gold.c14147db.png";